import React from "react";

import * as S from "./styles";

export const Slide1: React.FC = () => {
  const animeZoom = {
    scaling: {
      scale: [1, 1.1, 1],
      transition: { ease: "easeInOut", duration: 40, repeat: Infinity },
    },
  };
  return (
    <S.Container>
      <S.Background animate="scaling" variants={animeZoom} />
      <S.Content>
        <S.Wrapper>
          <S.Title>
            amor
            <br />
            de perto
          </S.Title>
          <S.Text>
            <p>
              De dois em dois meses – ou quando o abre e fecha de fronteiras
              permite –, nossa editora de moda Suyane Ynaya e o francês Mickael
              Gnougnou se encontram. E é bom.
            </p>
            <p>
              Fotos <span>Hick Duarte</span>
              <br />
              Edição de moda <span>Suyane Ynaya</span>
            </p>
          </S.Text>
        </S.Wrapper>
        <S.Credit>
          <p>
            Fotos <span>Hick Duarte</span>
            <br />
            Edição de moda <span>Suyane Ynaya</span>
          </p>
          Top, R$ 259, e lenço, R$ 69, Cotton Project. Hot pants, Haight, R$
          179. Brinco, R$ 680, e pulseira, R$ 600, ambos Skull.
        </S.Credit>
      </S.Content>
    </S.Container>
  );
};
